import { DialogActions, Grid } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { CSSProperties, FormEvent, ReactNode } from 'react';
import { RestError } from '@azure/core-http';
import { parseErrorMessage } from '../../../../core/api/api.context';
import { Modal } from '../../../../ui/components/pure/modal/modal.component';
import { TextButton } from '../../../../ui/components/pure/text-button/text-button.component';
import { Colors } from '../../../../ui/theme/colors';

export const fullWidthStyle: CSSProperties = { width: '100%' };
export const rowGroupStyle: CSSProperties = { width: '100%', margin: 0, padding: '8px 16px' };

const dialogActionsStyle: CSSProperties = {
  borderTop: `1px solid ${Colors.lightGray}`,
  padding: '16px 24px'
};

/** The chrome around a carrier form: title, save/cancel, and the API error. */
export function CarrierFormModal({
  title,
  saving,
  error,
  onCancel,
  onSubmit,
  children
}: {
  title: string;
  saving?: boolean;
  error?: RestError | Error;
  onCancel(): void;
  onSubmit(event: FormEvent): void;
  children: ReactNode;
}) {
  return (
    <Modal title={title} open={true} loading={saving} maxWidth="sm" divider>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Grid container sx={{ flexDirection: 'column' }} style={{ width: '100%', margin: 0 }}>
          {children}

          {error && (
            <Grid container spacing={2} style={rowGroupStyle}>
              <Grid size={12}>
                <Alert variant="outlined" severity="error">
                  <AlertTitle>Something went wrong</AlertTitle>
                  {parseErrorMessage(error.message)}
                </Alert>
              </Grid>
            </Grid>
          )}
        </Grid>
        <DialogActions style={dialogActionsStyle}>
          <TextButton color="secondary" variant="outlined" onClick={onCancel}>
            Cancel
          </TextButton>
          <TextButton color="primary" variant="contained" type="submit">
            Save
          </TextButton>
        </DialogActions>
      </form>
    </Modal>
  );
}
